/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateEventDto } from '../../models/update-event-dto';

export interface GoogleCalendarEventsControllerUpdateEvent$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Organizer email address
 */
  organizerEmail: string;

/**
 * Event ID
 */
  eventId: string;
  createdAt: string;
      body: UpdateEventDto
}

export function googleCalendarEventsControllerUpdateEvent(http: HttpClient, rootUrl: string, params: GoogleCalendarEventsControllerUpdateEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, googleCalendarEventsControllerUpdateEvent.PATH, 'put');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('organizerEmail', params.organizerEmail, {});
    rb.path('eventId', params.eventId, {});
    rb.path('createdAt', params.createdAt, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

googleCalendarEventsControllerUpdateEvent.PATH = '/thalea-google-events/google-calendar-events/{tenant}/{organizerEmail}/{eventId}/{createdAt}';
